import React, { useState, useContext, useEffect } from 'react';
import { GlobalContext } from '../../_helpers/GlobalState';
import './floating-contact-button.css';

export function FloatingContactButton() {
    const [isOpen, setIsOpen] = useState(false);
    const { WebsiteData } = useContext(GlobalContext);
    const [copied, setCopied] = useState('');

    // Get contact data from GlobalState or fallback to defaults
    const contactData = WebsiteData?.Website?.Footer?.Contact?.ContactList || ['+1234567890', 'info@rkgtech.com'];
    const phoneNumber = contactData[0] || '+1234567890';
    const emailAddress = contactData[2] || 'info@rkgtech.com';

    // Close popup when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isOpen && !event.target.closest('.floating-contact-container')) {
                setIsOpen(false);
            }
        };

        // Close on Escape key
        const handleEscape = (event) => {
            if (event.key === 'Escape' && isOpen) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen]);

    // Copy to clipboard functionality
    const copyToClipboard = async (text, type) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(type);
            setTimeout(() => setCopied(''), 2000);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };

    const togglePopup = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="floating-contact-container">
            {/* Floating Button */}
            <button
                className="floating-contact-button"
                onClick={togglePopup}
                aria-label="Contact us"
                aria-expanded={isOpen}
            >
                <i className="fas fa-phone-alt"></i>
            </button>

            {/* Popup Modal */}
            <div className={`contact-popup ${isOpen ? 'open' : ''}`}>
                <div className="popup-header">
                    <h3>Contact Us</h3>
                    <button
                        className="close-button"
                        onClick={togglePopup}
                        aria-label="Close contact popup"
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <div className="popup-content">
                    {/* Phone Section */}
                    <div className="contact-item">
                        <div className="contact-icon">
                            <i className="fas fa-phone"></i>
                        </div>
                        <div className="contact-details">
                            <h4>Phone</h4>
                            <a href={`tel:${phoneNumber}`} className="contact-link">
                                {phoneNumber}
                            </a>
                            <div className="contact-actions">
                                <button
                                    className="action-button"
                                    onClick={() => copyToClipboard(phoneNumber, 'phone')}
                                    aria-label="Copy phone number"
                                >
                                    <i className="fas fa-copy"></i>
                                    {copied === 'phone' ? 'Copied!' : 'Copy'}
                                </button>
                                <a
                                    href={`tel:${phoneNumber}`}
                                    className="action-button primary"
                                    aria-label="Call now"
                                >
                                    <i className="fas fa-phone"></i>
                                    Call
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Email Section */}
                    <div className="contact-item">
                        <div className="contact-icon">
                            <i className="fas fa-envelope"></i>
                        </div>
                        <div className="contact-details">
                            <h4>Email</h4>
                            <a href={`mailto:${emailAddress}`} className="contact-link">
                                {emailAddress}
                            </a>
                            <div className="contact-actions">
                                <button
                                    className="action-button"
                                    onClick={() => copyToClipboard(emailAddress, 'email')}
                                    aria-label="Copy email address"
                                >
                                    <i className="fas fa-copy"></i>
                                    {copied === 'email' ? 'Copied!' : 'Copy'}
                                </button>
                                <a
                                    href={`mailto:${emailAddress}`}
                                    className="action-button primary"
                                    aria-label="Send email"
                                >
                                    <i className="fas fa-envelope"></i>
                                    Email
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* WhatsApp Section (if phone number exists) */}
                    {/* {phoneNumber && (
                        <div className="contact-item">
                            <div className="contact-icon whatsapp">
                                <i className="fab fa-whatsapp"></i>
                            </div>
                            <div className="contact-details">
                                <h4>WhatsApp</h4>
                                <span className="contact-text">Chat with us</span>
                                <div className="contact-actions">
                                    <a
                                        href={`https://wa.me/${phoneNumber.replace(/[^\d]/g, '')}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="action-button whatsapp"
                                        aria-label="Chat on WhatsApp"
                                    >
                                        <i className="fab fa-whatsapp"></i>
                                        Chat
                                    </a>
                                </div>
                            </div>
                        </div>
                    )} */}

                    {/* Social Media Links */}
                    <div className="social-links">
                        <h4>Follow Us</h4>
                        <div className="social-buttons">
                            <a
                                href="#"
                                className="social-button facebook"
                                aria-label="Facebook"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fab fa-facebook-f"></i>
                            </a>
                            <a
                                href="#"
                                className="social-button linkedin"
                                aria-label="LinkedIn"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fab fa-linkedin-in"></i>
                            </a>
                            <a
                                href="#"
                                className="social-button instagram"
                                aria-label="Instagram"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <i className="fab fa-instagram"></i>
                            </a>
                     
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FloatingContactButton;
